@if (title && showTitle) {
  <h2 class="astral-section-heading astral-heading-with-help">
    <span>{{ title | translate }}</span>
    @if (helpText) {
      <astral-popover [helpText]="helpText"></astral-popover>
    }
  </h2>
}
<div [formGroup]="group" class="astral-stack-m">
  <astral-layout-group [columns]="2" [tabletColumns]="1" [mobileColumns]="1">
    @if (showRecipient) {
      <app-autocomplete-remote-paged
        [control]="group.controls['recipientContactId']"
        [defaultSearch]="'*'"
        [service]="contactService"
        (itemSelected)="recipientChanged($event)"
      ></app-autocomplete-remote-paged>
    }
    <astral-select [control]="group.controls['deliveryMethod']" [itemsSource]="invoiceDeliveryMethods"></astral-select>
    <astral-input [control]="group.controls['email']" type="email" inputMode="email"></astral-input>
  </astral-layout-group>
  <section class="astral-stack-m">
    <h3 class="astral-section-heading">{{ 'LEASE_AGREEMENT.INVOICE_ADDRESS_HEADER' | translate }}</h3>
    <app-postal-address
      [group]="group.controls['postalAddress']"
      [model]="model.postalAddress"
      [mandatory]="true"
      [showName]="true"
      [title]="undefined"
    ></app-postal-address>
  </section>
</div>
